import React, { memo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./assets/styles/index.styles";
import useElementVisible from "../app/hooks/useElementVisible";
import VisibilitySensor from "../VisibilitySensor";
import BoxDecoration from "../Decorations/Box";
import { IspirazionePageConfig } from "../configuration";
import { CharacterReveal } from "react-text-reveal";
import SlideUpHOC from "../SlideUpHOC";
import OnViewPortObserver from "../OnViewPortObserver";
import BlockRevealImage from "../BlockRevealImage";
import AssignId from "../AssignId";

const useStyles = makeStyles(styles);

function Ispirazione() {
  // visibility hook -- check if component is visible -- memoized for better performance no unnecesary rerenders
  const [state, setElemVisible] = useElementVisible({
    firstPhoto: false,
    secondPhoto: false,
    h3: false,
    p: false,
  });
  const classes = useStyles();
  return (
    <>
      <div className={classes.root}>
        <AssignId
          absolute
          y={IspirazionePageConfig.pageOffsetFromTopDesktop}
          yMobile={IspirazionePageConfig.pageOffsetFromTopMobile}
          id='ispirazione'
        />
        {/* decorative vectors */}
        <BoxDecoration
          left="-50%"
          right={0}
          top="130%"
          bottom={0}
          rotate="22.5deg"
          scale="1.5"
          hideMobile
          z={0}
        />
        <BoxDecoration
          left="-50%"
          right={0}
          top="130%"
          bottom={0}
          rotate="45deg"
          scale="1.5"
          hideMobile
          z={0}
        />
        <BoxDecoration
          left="-50%"
          right={0}
          top="130%"
          bottom={0}
          rotate="67.5deg"
          scale="1.5"
          hideMobile
          z={0}
        />
        <BoxDecoration
          left="-50%"
          right={0}
          top="130%"
          bottom={0}
          rotate="0deg"
          scale="1.5"
          hideMobile
          z={0}
        />
        <BlockRevealImage
          blockRevealClass={classes.reveal}
          imageClass={classes.img}
          imgAlt='refin'
          addShadowOnVisible
          isInView={state.firstPhoto}
          imageSrc={IspirazionePageConfig.images.first}
        />
        <OnViewPortObserver
          absolute
          y={IspirazionePageConfig.firstPhotoOffsetAnim}
          yMobile={IspirazionePageConfig.firstPhotoOffsetMobile}
          onEnterViewPort={() => setElemVisible("firstPhoto")}
        />
        <span className={classes.span}>
          {/* conditional rendering to prevent photo from animating on first load, not visible on screen **bug */}
          <CharacterReveal
            animateOpacity={false}
            canPlay={state.h3}
            className={classes.h3}
            characterOffsetDelay={0}
            copy={["Il gusto pregiato ", "della tradizione"]}
            direction={"bottom"}
            duration={800}
            ease={"cubic-bezier(0,0.4,0.4,1)"}
            offset={"100px"}
            multilineMasking={true}
            multilineOffsetDelay={0}
          />
          <OnViewPortObserver
            absolute
            y={IspirazionePageConfig.primaryTextOffset}
            yMobile={IspirazionePageConfig.primaryTextOffsetMobile}
            onEnterViewPort={() => setElemVisible("h3")}
          />
          <SlideUpHOC duration='1s' when={state.p} >
            <p className={classes.p}>
              {IspirazionePageConfig.content.second[0]}
              <strong className="strong">
                {IspirazionePageConfig.content.second[1]}
              </strong>
              {IspirazionePageConfig.content.second[2]}
              <strong className="strong">
                {IspirazionePageConfig.content.second[3]}
              </strong>
            </p>
          </SlideUpHOC>
          <OnViewPortObserver
            absolute
            y={IspirazionePageConfig.subTextOffset}
            yMobile={IspirazionePageConfig.subTextOffsetMobile}
            onEnterViewPort={() => setElemVisible("p")}
          />
          <SlideUpHOC duration='1s' when={state.p} >
            <p className={classes.p}>
              {IspirazionePageConfig.content.third[0]}
              <strong className="strong">{IspirazionePageConfig.content.third[1]}</strong>
              {IspirazionePageConfig.content.third[2]}
              <strong className="strong">{IspirazionePageConfig.content.third[3]}</strong>
              {IspirazionePageConfig.content.third[4]}
            </p>
          </SlideUpHOC>
        </span>
      </div>
      <div className={classes.secondRoot}>
        <OnViewPortObserver
          absolute
          y={IspirazionePageConfig.secondPhotoOffset}
          yMobile={IspirazionePageConfig.secondPhotoOffsetMobile}
          onEnterViewPort={() => setElemVisible("secondPhoto")}
        />
        <BlockRevealImage
          blockRevealClass={classes.secondReveal}
          imageClass={classes.secondImg}
          imgAlt='refin'
          addShadowOnVisible
          isInView={state.secondPhoto}
          imageSrc={IspirazionePageConfig.images.second}
        />
      </div>
      <VisibilitySensor index={1} />
    </>
  );
}

export default memo(Ispirazione);
